module.exports = __webpack_public_path__ + "static/media/rollerImg.b9bc1f58.png";